module.exports = __webpack_public_path__ + "static/img/20-2.9b1e462.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20-2.jpg
// module id = h/qV
// module chunks = 0